import Axios from 'axios'
import Moment from 'moment'
import Push from 'push.js'
import * as actionTypes from './actionTypes'
import NotificationIconx16 from '../assets/images/notification-icon-16.png'
import NotificationIconx32 from '../assets/images/notification-icon-32.png'

const API_URL = 'https://api.integrada.ind.br/api'
const BROKER_HOST = 'iot.eclipse.org'
const BROKER_PORT = 443

/* MQTT Client */

export const mqttNewClient = (client) => {
  return {
    type: actionTypes.MQTT_NEW_CLIENT,
    payload: {
      client
    }
  }
}

export const mqttNewMessage = (topic, message) => {
  return {
    type: actionTypes.MQTT_NEW_MESSAGE,
    payload: {
      topicValues: topic.split('/'),
      messageValues: message.split(',')
    }
  }
}

export const mqttConnect = (user, password, topics) => {
  return (dispatch) => {
    let client = new window.Paho.MQTT.Client(BROKER_HOST, BROKER_PORT, 'web-app-' + Number(new Date()))

    client.onConnectionLost = (responseObject) => {
      if (responseObject.errorCode !== 0) {
        dispatch(mqttConnect(user, password, topics))
      }
    }

    client.onMessageArrived = ({
      destinationName,
      payloadString
    }) => dispatch(mqttNewMessage(destinationName, payloadString))

    if (user && password) {
      client.connect({
        userName: user,
        password: password,
        onSuccess: () => {
          topics.map(topic => client.subscribe(topic))
        },
        useSSL: true
      })
    } else {
      client.connect({
        onSuccess: () => {
          topics.map(topic => client.subscribe(topic))
        },
        useSSL: true
      })
    }

    dispatch(mqttNewClient(client))
  }
}

/* Load Bombs */
export const loadTanksSuccess = (buildingId, tanks) => {
  return {
    type: actionTypes.LOAD_TANKS_SUCCESS,
    payload: {
      buildingId, tanks
    }
  }
}

export const loadTanksError = (error) => {
  return {
    type: actionTypes.LOAD_TANKS_ERROR,
    payload: error,
    error: true
  }
}

export const loadTanksLoading = (loading) => {
  return {
    type: actionTypes.LOAD_TANKS_LOADING,
    payload: {loading}
  }
}

export const loadTanks = (buildingId) => {
  return (dispatch, getState) => {
    dispatch(loadTanksLoading(true))
    const {
      auth
    } = getState()
    Axios.get(`${API_URL}/mais_agua/tanks/?building=${buildingId}&limit=5`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      dispatch(loadTanksSuccess(buildingId, response.data.results))
      dispatch(loadTanksLoading(false))
    }).catch(error => {
      dispatch(loadTanksError(error))
    })
  }
}

/* Load Buildings */
export const loadBuildingsSuccess = (buildings) => {
  return {
    type: actionTypes.LOAD_BUILDINGS_SUCCESS,
    payload: {
      buildings
    }
  }
}

export const loadBuildingsError = (error) => {
  return {
    type: actionTypes.LOAD_BUILDINGS_ERROR,
    payload: error,
    error: true
  }
}

export const loadBuildingsLoading = (loading) => {
  return {
    type: actionTypes.LOAD_BUILDINGS_LOADING,
    payload: {loading}
  }
}

export const loadBuildings = (condominiumId) => {
  return (dispatch, getState) => {
    dispatch(loadBuildingsLoading(true))
    const {
      auth
    } = getState()
    Axios.get(`${API_URL}/mais_agua/buildings/?condominium=${condominiumId}&limit=100`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      let buildings = response.data.results
      dispatch(loadBuildingsSuccess(buildings))
      buildings.forEach(building=>dispatch(loadTanks(building.id)))
      dispatch(loadBuildingsLoading(false))
    }).catch(error => {
      dispatch(loadBuildingsError(error))
    })
  }
}

/* Load Bombs */
export const loadBombsSuccess = (cisternId, bombs) => {
  return {
    type: actionTypes.LOAD_BOMBS_SUCCESS,
    payload: {
      cisternId, bombs
    }
  }
}

export const loadBombsError = (error) => {
  return {
    type: actionTypes.LOAD_BOMBS_ERROR,
    payload: error,
    error: true
  }
}

export const loadBombsLoading = (loading) => {
  return {
    type: actionTypes.LOAD_BOMBS_LOADING,
    payload: {loading}
  }
}

export const loadBombs = (cisternId) => {
  return (dispatch, getState) => {
    dispatch(loadBombsLoading(true))
    const {
      auth
    } = getState()
    Axios.get(`${API_URL}/mais_agua/bombs/?cistern=${cisternId}&limit=1`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      dispatch(loadBombsSuccess(cisternId, response.data.results))
      dispatch(loadBombsLoading(false))
    }).catch(error => {
      dispatch(loadBombsError(error))
    })
  }
}

/* Load Cisterns */
export const loadCisternsSuccess = (cisterns) => {
  return {
    type: actionTypes.LOAD_CISTERNS_SUCCESS,
    payload: {
      cisterns
    }
  }
}

export const loadCisternsError = (error) => {
  return {
    type: actionTypes.LOAD_CISTERNS_ERROR,
    payload: error,
    error: true
  }
}

export const loadCisternsLoading = (loading) => {
  return {
    type: actionTypes.LOAD_CISTERNS_LOADING,
    payload: {loading}
  }
}

export const loadCisterns = (condominiumId) => {
  return (dispatch, getState) => {
    dispatch(loadCisternsLoading(true))
    const {
      auth
    } = getState()
    Axios.get(`${API_URL}/mais_agua/cisterns/?condominium=${condominiumId}&limit=100`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      let cisterns = response.data.results
      dispatch(loadCisternsSuccess(cisterns))
      cisterns.forEach(cistern => dispatch(loadBombs(cistern.id)))
      dispatch(loadCisternsLoading(false))
    }).catch(error => {
      dispatch(loadCisternsError(error))
    })
  }
}

/* Load Notifications */
const compareNotificationRequirement = (notification, requirement, information) => {
  const ANY = 0
  const NOT_EQUAL_TO = 1
  const EQUAL_TO = 2
  const LESS_THAN = 3
  const LESS_THAN_OR_EQUAL_TO = 4
  const GREATER_THAN_OR_EQUAL_TO = 5
  const GREATER_THAN = 6

  if (information.updates === undefined || information.updates.length === 0) {
    return false
  }
  switch (requirement.compare) {
    case ANY:
      if (notification.launch_at === undefined) {
        return true
      }
      return Moment(information.updates[0].created_at).unix() > Moment(notification.launch_at).unix()
    case NOT_EQUAL_TO:
      return information.updates[0].data !== requirement.data
    case EQUAL_TO:
      return information.updates[0].data === requirement.data
    case LESS_THAN:
      return information.updates[0].data < requirement.data
    case LESS_THAN_OR_EQUAL_TO:
      return information.updates[0].data <= requirement.data
    case GREATER_THAN_OR_EQUAL_TO:
      return information.updates[0].data >= requirement.data
    case GREATER_THAN:
      return information.updates[0].data > requirement.data
    default:
      return false
  }
}

const areNotificationRequirementsMet = (notification, informations) => {
  let result = true
  let requirementInformations = []

  notification.requirements.forEach(requirement => {
    if (result === false) {
      return
    }
    const information = informations.find(information => information.id === requirement.information)
    if (information) {
      requirementInformations.push(information)
      result = compareNotificationRequirement(notification, requirement, information)
      if (result === true) {
        result = requirement.validation_delta <= Moment().unix() - Moment(information.updates[0].created_at).unix()
      }
    } else {
      result = false
    }
  })

  if (result === true && notification.clicked_at !== undefined) {
    result = requirementInformations.some(information => Moment(information.updates[0].created_at).unix() > Moment(notification.clicked_at).unix())
  }

  return result
}

export const handleClickNotification = (notification) => {
  return {
    type: actionTypes.CLICK_NOTIFICATION,
    payload: {
      notificationId: notification.id
    }
  }
}

export const launchNotification = (notification) => {
  return (dispatch, getState) => {
    const tag = `${notification.id}-${Number(new Date())}`
    Push.create(notification.title, {
      body: notification.message,
      icon: {
        x16: NotificationIconx16,
        x32: NotificationIconx32
      },
      tag: tag,
      onClick: () => {
        window.focus()
        Push.close(tag)
        dispatch(handleClickNotification(notification))
      },
      timeout: notification.duration * 1000
    })

    dispatch({
      type: actionTypes.LAUNCH_NOTIFICATION,
      payload: {
        notificationId: notification.id
      }
    })
  }
}

export const handleNotifications = () => {
  return (dispatch, getState) => {
    const { informations, notifications, dashboard } = getState()

    notifications.forEach(notification => {
      if (areNotificationRequirementsMet(notification, informations)) {
        if (notification.launch_at) {
          if (notification.interval <= Moment().unix() - Moment(notification.launch_at).unix()) {
            dispatch(launchNotification(notification))
          }
        } else {
          dispatch(launchNotification(notification))
        }
      }
    })

    if (dashboard.notificationTimeoutId) {
      window.clearTimeout(dashboard.notificationTimeoutId)
    }

    const timeoutId = window.setTimeout(() => {
      dispatch(handleNotifications())
    }, 1000)

    dispatch({
      type: actionTypes.HANDLE_NOTIFICATIONS,
      payload: {
        timeoutId
      }
    })
  }
}

export const loadNotificationsSuccess = (notifications) => {
  return {
    type: actionTypes.LOAD_NOTIFICATIONS_SUCCESS,
    payload: {
      notifications
    }
  }
}

export const loadNotificationsError = (error) => {
  return {
    type: actionTypes.LOAD_NOTIFICATIONS_ERROR,
    payload: error,
    error: true
  }
}

export const loadNotificationsLoading = (loading) => {
  return {
    type: actionTypes.LOAD_NOTIFICATIONS_LOADING,
    payload: {loading}
  }
}

export const loadNotifications = (condominium) => {
  return (dispatch, getState) => {
    dispatch(loadNotificationsLoading(true))
    const {
      auth
    } = getState()
    Axios.get(`${API_URL}/iot/notifications/?condominium=${condominium}&limit=100`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      dispatch(loadNotificationsSuccess(response.data.results))
      dispatch(handleNotifications())
      dispatch(loadNotificationsLoading(false))
    }).catch(error => {
      dispatch(loadNotificationsError(error))
    })
  }
}

/* Load Information Updates */
export const loadInformationUpdatesSuccess = (informationId, updates) => {
  return {
    type: actionTypes.LOAD_INFORMATION_UPDATES_SUCCESS,
    payload: {
      informationId,
      updates
    }
  }
}

export const loadInformationUpdatesError = (error) => {
  return {
    type: actionTypes.LOAD_INFORMATION_UPDATES_ERROR,
    payload: error,
    error: true
  }
}

export const loadInformationUpdatesLoading = (loading) => {
  return {
    type: actionTypes.LOAD_INFORMATION_UPDATES_LOADING,
    payload: {loading}
  }
}

export const loadInformationUpdates = (informationId) => {
  return (dispatch, getState) => {
    dispatch(loadInformationUpdatesLoading(true))
    const {
      auth
    } = getState()
    Axios.get(`${API_URL}/iot/information_updates/?information=${informationId}&limit=5`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      dispatch(loadInformationUpdatesSuccess(informationId, response.data.results))
      dispatch(loadInformationUpdatesLoading(false))
    }).catch(error => {
      dispatch(loadInformationUpdatesError(error))
    })
  }
}

/* Load Informations */
export const loadInformationsSuccess = (informations) => {
  return {
    type: actionTypes.LOAD_INFORMATIONS_SUCCESS,
    payload: {
      informations
    }
  }
}

export const loadInformationsError = (error) => {
  return {
    type: actionTypes.LOAD_INFORMATIONS_ERROR,
    payload: error,
    error: true
  }
}

export const loadInformationsLoading = (loading) => {
  return {
    type: actionTypes.LOAD_INFORMATIONS_LOADING,
    payload: {loading}
  }
}

export const loadInformations = (moduleId) => {
  return (dispatch, getState) => {
    dispatch(loadInformationsLoading(true))
    const {
      auth, modules, hubs
    } = getState()
    let module = modules.find(module => module.id === moduleId)
    let hub = hubs.find(hub => hub.id === module.hub)
    Axios.get(`${API_URL}/iot/informations/?module=${moduleId}&limit=100`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      let informations = response.data.results.map(information => {
        information.module_identifier = module.identifier
        information.hub = hub.id
        information.hub_identifier = hub.alias ? hub.alias : hub.mqtt_user
        dispatch(loadInformationUpdates(information.id))
        return information
      })
      dispatch(loadInformationsSuccess(informations))
      dispatch(loadInformationsLoading(false))
    }).catch(error => {
      dispatch(loadInformationsError(error))
    })
  }
}


/* Load Command Logs */
export const loadCommandLogsSuccess = (commandId, logs) => {
  return {
    type: actionTypes.LOAD_COMMAND_LOGS_SUCCESS,
    payload: {
      commandId,
      logs
    }
  }
}

export const loadCommandLogsError = (error) => {
  return {
    type: actionTypes.LOAD_COMMAND_LOGS_ERROR,
    payload: error,
    error: true
  }
}

export const loadCommandLogsLoading = (loading) => {
  return {
    type: actionTypes.LOAD_COMMAND_LOGS_LOADING,
    payload: {loading}
  }
}

export const loadCommandLogs = (commandId) => {
  return (dispatch, getState) => {
    dispatch(loadCommandLogsLoading(true))
    const {
      auth
    } = getState()
    Axios.get(`${API_URL}/iot/command_logs/?command=${commandId}&limit=5`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      dispatch(loadCommandLogsSuccess(commandId, response.data.results))
      dispatch(loadCommandLogsLoading(false))
    }).catch(error => {
      dispatch(loadCommandLogsError(error))
    })
  }
}

/* Load Commands */

export const loadCommandsSuccess = (commands) => {
  return {
    type: actionTypes.LOAD_COMMANDS_SUCCESS,
    payload: {
      commands
    }
  }
}

export const loadCommandsError = (error) => {
  return {
    type: actionTypes.LOAD_COMMANDS_ERROR,
    payload: error,
    error: true
  }
}

export const loadCommandsLoading = (loading) => {
  return {
    type: actionTypes.LOAD_COMMANDS_LOADING,
    payload: {loading}
  }
}

export const loadCommands = (moduleId) => {
  return (dispatch, getState) => {
    dispatch(loadCommandsLoading(true))
    const {
      auth, modules, hubs
    } = getState()
    let module = modules.find(module => module.id === moduleId)
    let hub = hubs.find(hub => hub.id === module.hub)
    Axios.get(`${API_URL}/iot/commands/?module=${moduleId}&limit=100`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      let commands = response.data.results.map(command => {
        command.module_identifier = module.identifier
        command.hub = hub.id
        command.hub_identifier = hub.alias ? hub.alias : hub.mqtt_user
        dispatch(loadCommandLogs(command.id))
        return command
      })
      dispatch(loadCommandsSuccess(commands))
      dispatch(loadCommandsLoading(false))
    }).catch(error => {
      dispatch(loadCommandsError(error))
    })
  }
}

/* Load Modules */
export const loadModulesSuccess = (modules) => {
  return {
    type: actionTypes.LOAD_MODULES_SUCCESS,
    payload: {
      modules
    }
  }
}

export const loadModulesError = (error) => {
  return {
    type: actionTypes.LOAD_MODULES_ERROR,
    payload: error,
    error: true
  }
}

export const loadModulesLoading = (loading) => {
  return {
    type: actionTypes.LOAD_MODULES_LOADING,
    payload: {loading}
  }
}

export const loadModules = (hubId) => {
  return (dispatch, getState) => {
    dispatch(loadModulesLoading(true))
    const {
      auth
      } = getState()
    Axios.get(`${API_URL}/iot/modules/?hub=${hubId}&limit=100`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      let modules = response.data.results
      dispatch(loadModulesSuccess(modules))
      modules.forEach(module => {
        dispatch(loadCommands(module.id))
        dispatch(loadInformations(module.id))
      })
      dispatch(loadModulesLoading(false))
    }).catch(error => {
      dispatch(loadModulesError(error))
    })
  }
}

/* Load Hub Status */
export const loadHubStatusSuccess = (hubStatus) => {
  return {
    type: actionTypes.LOAD_HUB_STATUS_SUCCESS,
    payload: {
      hubStatus
    }
  }
}

export const loadHubStatusError = (error) => {
  return {
    type: actionTypes.LOAD_HUB_STATUS_ERROR,
    payload: error,
    error: true
  }
}

export const loadHubStatusLoading = (loading) => {
  return {
    type: actionTypes.LOAD_HUB_STATUS_LOADING,
    payload: {loading}
  }
}

export const loadHubStatus = (hubId) => {
  return (dispatch, getState) => {
    dispatch(loadHubStatusLoading(true))
    const {
      auth
    } = getState()
    Axios.get(`${API_URL}/iot/hub_status/?hub=${hubId}&limit=1`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      dispatch(loadHubStatusSuccess(response.data.results[0]))
      dispatch(loadHubStatusLoading(false))
    }).catch(error => {
      dispatch(loadHubStatusError(error))
    })
  }
}

/* Load Hubs */
export const loadHubsSuccess = (hubs) => {
  return {
    type: actionTypes.LOAD_HUBS_SUCCESS,
    payload: {
      hubs
    }
  }
}

export const loadHubsError = (error) => {
  return {
    type: actionTypes.LOAD_HUBS_ERROR,
    payload: error,
    error: true
  }
}

export const loadHubsLoading = (loading) => {
  return {
    type: actionTypes.LOAD_HUBS_LOADING,
    payload: {loading}
  }
}

export const loadHubs = (condominiumId) => {
  return (dispatch, getState) => {
    dispatch(loadHubsLoading(true))
    const {
      auth
    } = getState()
    Axios.get(`${API_URL}/iot/hubs/?condominium=${condominiumId}&limit=100`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      response.data.results.forEach(hub => {
        dispatch(loadHubStatus(hub.id))
        dispatch(loadModules(hub.id))
      })
      dispatch(loadHubsSuccess(response.data.results))
      dispatch(loadHubsLoading(false))
    }).catch(error => {
      dispatch(loadHubsError(error))
    })
  }
}

/* Load Condominium */
export const loadCondominiumSuccess = (condominium) => {
  return {
    type: actionTypes.LOAD_CONDOMINIUM_SUCCESS,
    payload: {
      condominium
    }
  }
}

export const loadCondominiumError = (error) => {
  return {
    type: actionTypes.LOAD_CONDOMINIUM_ERROR,
    payload: error,
    error: true
  }
}

export const loadCondominiumLoading = (loading) => {
  return {
    type: actionTypes.LOAD_CONDOMINIUM_LOADING,
    payload: {loading}
  }
}

export const loadCondominium = (id) => {
  return (dispatch, getState) => {
    dispatch(loadCondominiumLoading(true))
    const {
      auth
    } = getState()
    Axios.get(`${API_URL}/mais_agua/condominiums/${id}/`, {
      headers: {
        'Authorization': `JWT ${auth.token}`
      }
    }).then(response => {
      dispatch(loadCondominiumSuccess(response.data))
      dispatch(loadBuildings(response.data.id))
      dispatch(loadCisterns(response.data.id))
      dispatch(loadHubs(response.data.id))
      dispatch(loadCondominiumLoading(false))
    }).catch(error => {
      dispatch(loadCondominiumError(error))
    })
  }
}

/* Load */
export const load = () => {
  return (dispatch, getState) => {
    let { condominium } = getState()
    dispatch({
      type: actionTypes.LOAD_STARTED,
      payload: {}
    })
    dispatch(loadBuildings(condominium.id))
    dispatch(loadCisterns(condominium.id))
    dispatch(loadHubs(condominium.id))
    dispatch(loadNotifications(condominium.id))
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/dashboardActions.js
 **/